import React from 'react';
import fr from 'facet-rest';
import {
  SET_ERROR,
  SET_STEPS,
  setActiveStep,
  useFormStepCollectionContext,
} from 'Components/UI/Accounts/AccountApplication/AccountApplicationContext';
import PropTypes from 'prop-types';
import useQueryParams from 'Hooks/useQueryParams';
import { removeQuery } from 'Helpers/Query';

const AccountApplicationContainer = ({ children, link }) => {
  const { dispatch, state } = useFormStepCollectionContext();
  const [queryParams] = useQueryParams();

  React.useEffect(() => {
    async function loadAccountApplication() {
      const coll = await fr.http.get(link);
      dispatch({ type: SET_STEPS, steps: coll });
    }
    loadAccountApplication().catch(() => {
      dispatch({ type: SET_ERROR, message: 'Failed to load account application...' });
    });
  }, [link]);

  React.useEffect(() => {
    if (queryParams.has('activeStep') && state.activeStep !== Number(queryParams.get('activeStep'))) {
      dispatch(setActiveStep(Number(queryParams.get('activeStep'))));
    }
  }, [queryParams.get('activeStep')]);

  React.useEffect(() => {
    return () => {
      removeQuery('activeStep');
    };
  }, []);

  return children;
};

AccountApplicationContainer.defaultProps = {
  className: '',
  children: null,
};

AccountApplicationContainer.propTypes = {
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default AccountApplicationContainer;
